import { render } from "./PushManagement.vue?vue&type=template&id=4bc89ad8&scoped=true"
import script from "./PushManagement.vue?vue&type=script&lang=js"
export * from "./PushManagement.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4bc89ad8"

export default script